import React from "react"
import { Box } from "@mui/material"
import { formatDate } from "@ui-seeker/utils"

import BITableCell from "./Cell"
import { validateFormat } from "@utils"


export default function dateColumn(date, idx) {

	const checkDateFormat = validateFormat('yyyyMMdd', date) ? formatDate(date, {
		isString: true,
		receivedFormat: 'yyyyMMdd'
	}) : date

	return {
		name: date,
		options: {
			filter: false,
			sortCompare: (order) => {
				return (obj1, obj2) => (obj1.data.price - obj2.data.price) * (order === 'asc' ? 1 : -1)
			},
			customHeadLabelRender: () => <Box
				sx={{ fontWeight: 600, display: 'block', textAlign: 'center' }}>{checkDateFormat}</Box>,
			setCellProps: () => ({ sx: { px: .5 } }),
			customBodyRowRenderLite: (value, row) => {
				const keys = Object.keys(row).filter(a => !a.includes('name'))
				const data = row[keys[idx]]

				return <Box>
					<BITableCell
						price={data?.price}
						currency={data?.price_data?.id_master_currency_translation}
						noEvolutionChange={data?.noEvolutionChange}
						evolutionChange={data?.evolutionChange}
						evolutionDiff={data?.evolutionDiff}
						noResult={data?.noResult}
						prevPrice={data?.previous_price}
						isCheapest={data?.isCheapestColumn}
						isMoreExpensive={data?.isMoreExpensiveColumn}
					/>
				</Box>
			}
		}
	}
}